export enum CampaignStatus {
    DRAFT = 'DRAFT',
    PUBLISHING = 'PUBLISHING',
    SCHEDULED = 'SCHEDULED',
    IN_PROGRESS = 'IN_PROGRESS', // @deprecated - Use PREPARING_TO_SEND or SENDING instead
    PREPARING_TO_SEND = 'PREPARING_TO_SEND',
    SENDING = 'SENDING',
    COMPLETED = 'COMPLETED',
    FAILURE = 'FAILURE',
    READY = 'READY',
    AWAITING_USER_INPUT = 'AWAITING_USER_INPUT',
    TRACKING_CONVERSIONS = 'TRACKING_CONVERSIONS',
}
